export const appName = "Commarec";
